export const GOOGLE_MAPS_API_KEY =
  process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ||
  'AIzaSyDjx0QsOIj6kV1G-UkHSzZBtiRwaDQ9TrM';
